module.exports = __webpack_public_path__ + "img/lang-ar.45164c0a.svg";